import { create } from 'zustand';

export interface AlertToast {
  id: string;
  kind: 'new_alert' | 'assigned';
  title: string;
  body: string;
  createdAt: number;
}

interface ToastState {
  toasts: AlertToast[];
  push: (toast: Omit<AlertToast, 'id' | 'createdAt'>) => void;
  dismiss: (id: string) => void;
}

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  push: (toast) =>
    set((s) => ({
      toasts: [
        ...s.toasts,
        { ...toast, id: crypto.randomUUID(), createdAt: Date.now() },
      ].slice(-5), // keep at most 5 toasts visible at once
    })),
  dismiss: (id) =>
    set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));

/** Called from emergency-store (non-React context) to enqueue a toast. */
export function pushAlertToast(toast: Omit<AlertToast, 'id' | 'createdAt'>) {
  useToastStore.getState().push(toast);
}
